/* eslint-disable @typescript-eslint/no-explicit-any */
export var StatFlags;

(function (StatFlags) {
  StatFlags[StatFlags["None"] = 0] = "None";
  StatFlags[StatFlags["Anonymous"] = 1] = "Anonymous";
  StatFlags[StatFlags["OnceInSession"] = 2] = "OnceInSession";
  StatFlags[StatFlags["OnlyFirstSession"] = 4] = "OnlyFirstSession";
  StatFlags[StatFlags["OnlyForWorker"] = 8] = "OnlyForWorker";
  StatFlags[StatFlags["SendImmediately"] = 16] = "SendImmediately";
  StatFlags[StatFlags["NoCommonParams"] = 32] = "NoCommonParams";
})(StatFlags || (StatFlags = {}));